import OtpInput from "react-otp-input";
import React, { Fragment, useState, useEffect } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import { compareDesc } from "date-fns/fp";
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import * as constants from "../../utils/Constants";
import { CircularProgress } from '@mui/material';

export default function App() {
  const [isSpin, setIsSpin] = useState(false);
  let history = useHistory();
  const [code, setCode] = useState({});
  const [mobileCode, setmobileCode] = useState({});
  const loggedInUser = JSON.parse(localStorage.getItem("user"));
  const handleChange = (otp) => {
    let otpInput = {};
    otpInput["emailOTP"] = otp;
    setCode(otpInput);
  };
  const handleChange1 = (mobileOTP) => {
    let otpInput1 = {};
    otpInput1["mobileOTP"] = mobileOTP;
    setmobileCode(otpInput1);
  };
  const [OTP, setOTP] = useState("");
  const [mobileOTP, setmobileOTP] = useState("");
  const [loginData, setLoginData] = useState({});
  let state = useLocation().state;
  if (!state) {
    state = {
      emailOTP: "",
      mobileOTP: "",
    };
  }
  const submitHandler1 = (e) => {
    setIsSpin(true);
    // e.preventDefault()
    var url = constants.OtpVerificationUrl;
    const payload = {
      emailOTP: code.emailOTP,
      emailId: state.email,
      mobileOTP: mobileCode.mobileOTP,
      mobileNumber: state.mobile,
    };
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Schema: constants.Schema,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((res) => {
        // console.log(res)
        if (res.message) {
          toast.success(`✅ ${res.message.messageDescription} !`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setTimeout(() => {
            history.push("/page-login");
          }, 3000);
        } else if (res.error) {
          toast.error(`❌ ${res.error.errorMessage} !`, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setTimeout(() => {
            setIsSpin(false);
          }, 3000);
          setCode({});
          setmobileCode({});
        }
      });
  };

  // email and phone resend otp
  const emailResendOtp = () => {
    var url = `${constants.emailResendOtpUrl}/${state.email}`;
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Schema: constants.Schema,
      },
      body: JSON.stringify(loginData),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.message) {
          toast.success(`✅ ${res.message.messageDescription} !`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        } else if (res.error) {
          toast.error(`❌ ${res.error.errorMessage} !`, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
      });
  };

  const mobileResendOtp = () => {
    var url = `${constants.phoneResendOtpUrl}/${state.email}`;
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Schema: constants.Schema,
      },
      body: JSON.stringify(loginData),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.message) {
          toast.success(`✅ ${res.message.messageDescription} !`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        } else if (res.error) {
          toast.error(`❌ ${res.error.errorMessage} !`, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
      });
  };

  return (
    <div className="authentication h-100 p-meddle">
      {/* <div className='container h-100'> */}
      <div>
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-6">
            <div className="authentication-content">
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <div className="auth-form">
                    <div className="text-center mb-3"></div>
                    <div className="form-group">
                      <label className="mb-1 text-#58595b">
                        <h2 className="card-title">Verify Your Account</h2>
                        <p>
                          A verification code has been send to your mail id{" "}
                          {state.email} (OTP valid for 5 minutes)
                        </p>
                      </label>
                      <OtpInput
                        value={code.emailOTP}
                        //defaultValue={state.emailOTP}
                        name="emailOTP"
                        onChange={handleChange}
                        numInputs={6}
                        separator={
                          <span
                            style={{ width: "8px", color: "#00ADEE" }}
                          ></span>
                        }
                        isInputNum={true}
                        shouldAutoFocus={true}
                        inputStyle={{
                          border: "1px solid #00ADEE",
                          borderRadius: "8px",
                          width: "54px",
                          height: "54px",
                          fontSize: "12px",
                          color: "#58595b",
                          fontWeight: "400",
                          caretColor: "#58595b",
                        }}
                        focusStyle={{
                          border: "1px solid #00ADEE",
                          outline: "none",
                        }}
                      />
                      <br></br>

                      <div style={{ marginLeft: "100px", fontSize: "14px" }}>
                        <span>Didn't Receive a code?</span>
                        <br />
                        <button
                          className="btn"
                          style={{
                            color: "#00ADEE",
                            border: "none",
                            marginLeft: "30px",
                          }}
                          type="button"
                          onClick={emailResendOtp}
                        >
                          Resend
                        </button>
                      </div>
                      <br></br>
                      <p>
                        A verification code has been send to your registered
                        mobile number {state.mobile} (OTP valid for 5 minutes)
                      </p>
                      <OtpInput
                        value={mobileCode.mobileOTP}
                        name="mobileOTP"
                        onChange={handleChange1}
                        numInputs={6}
                        separator={
                          <span
                            style={{ width: "8px", color: "#00ADEE" }}
                          ></span>
                        }
                        isInputNum={true}
                        shouldAutoFocus={true}
                        inputStyle={{
                          border: "1px solid #00ADEE",
                          borderRadius: "8px",
                          width: "54px",
                          height: "54px",
                          fontSize: "12px",
                          color: "#58595b",
                          fontWeight: "400",
                          caretColor: "#58595b",
                        }}
                        focusStyle={{
                          border: "1px solid #00ADEE",
                          outline: "none",
                        }}
                      />
                      <br></br>
                      <div style={{ marginLeft: "100px", fontSize: "14px" }}>
                        <span>Didn't Receive a code?</span>
                        <br />
                        <button
                          className="btn"
                          style={{
                            color: "#00ADEE",
                            border: "none",
                            marginLeft: "30px",
                          }}
                          type="button"
                          onClick={mobileResendOtp}
                        >
                          Resend
                        </button>
                      </div>
                      <br></br>
                      {isSpin ? (
                        <button
                          type="button"
                          className="btn bg-white text-primary"
                        >
                          <CircularProgress
                            color="inherit"
                            size={24}
                            sx={{
                              color: "green",
                            }}
                          />
                        </button>
                      ) : (
                        <>
                          <button
                            style={{
                              border: "none",
                              backgroundColor: "#00ADEE",
                              marginTop: 21,
                              marginBottom: 21,
                            }}
                            className="btn btn-primary btn-sm"
                            type="submit"
                            onClick={() => submitHandler1()}
                          >
                            Verify
                          </button>
                        </>
                      )}
                      <div className="new-account mt-3 text-#58595b">
                        <p>
                          Already Verified?{" "}
                          <Link style={{ color: "#00ADEE" }} to="/page-login">
                            Sign in
                          </Link>
                        </p>
                      </div>
                      <ToastContainer />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
